import periodRangeToMs from './periodRangeToMs'
import formatPeriodLabel from './formatPeriodLabel'

// AI-CONTEXT: See docs/features/deep-analysis-period.md
// AI-CONTEXT: See docs/pitfalls.md#api-callable-timestamp-vs-ms
//
// The page period as Decca's contextData.periods — the contract checked by
// functions/utils/parseAnalysisPeriods.js: { A: {startMs, endMs, label}, B? }.
// Epoch-ms numbers (never Dates), and the same label the user sees above the
// charts. Null without a period: then nothing is sent and Decca analyses all
// data, exactly as before.

/**
 * @typedef {object} AIPeriod
 * @property {number} startMs
 * @property {number} endMs
 * @property {string} label
 */

/** @param {{start: string|null, end: string|null}|null} range @returns {AIPeriod} */
const toAIPeriod = (range) => ({ ...periodRangeToMs(range), label: formatPeriodLabel(range) })

/**
 * @param {{rangeA: object|null, rangeB: object|null, compareActive: boolean}|null} period - From DeepAnalysisPeriodContext
 * @returns {{A: AIPeriod, B?: AIPeriod}|null}
 */
const periodsForAI = (period) => {
    if (!period || (!period.rangeA && !period.compareActive)) return null
    return period.compareActive
        ? { A: toAIPeriod(period.rangeA), B: toAIPeriod(period.rangeB) }
        : { A: toAIPeriod(period.rangeA) }
}

export default periodsForAI
